import RoutesMap from "route_control/RouteControl"
import { Dashboard } from "pages/dashboard"

const DashboardRoute = () => {
    return [
        {
            path: RoutesMap.DASHBOARD.path,
            element: <Dashboard />
        },
        {
            path: RoutesMap.DASHBOARDSECOND.path,
            element: <Dashboard />
        }
    ]
}

export default DashboardRoute;